import { Form } from 'utils/hooks'
import { Flex } from 'components/shared/flex'
import { CheckboxField, DateField, InputField } from 'components/shared/input'
import { Button } from 'react-bootstrap'
import { Dispatch, SetStateAction } from 'react'
import misignalCalculatorAxiosBase from 'utils/network/misignal_calculator_axios_base'
import { CheckHabit, CheckSample } from 'entities/check_sample'
import { CheckTestResultForm } from 'api/result_check'

type CheckTestViewProps = {
    form: Form<CheckTestResultForm>
    formPrev: Form<CheckTestResultForm>
    formPrev2: Form<CheckTestResultForm>
    formPrev3: Form<CheckTestResultForm>
    formPrev4: Form<CheckTestResultForm>
    habits: CheckHabit[]
    setSample: Dispatch<SetStateAction<CheckSample | undefined>>
}

export const CheckTestView = ({ form, formPrev, formPrev2, formPrev3, formPrev4, habits, setSample }: CheckTestViewProps) => {
    const patientId = "xxxxxx" // patientIdは文字列になるように仕様変更 2024/10
    const generateEnabledJson = () => {
        const samples = [form, formPrev, formPrev2, formPrev3, formPrev4].filter((f) => f.object.enabled).map((f, index) => formatFormData(f, index + 1))

        return {
            version: '1.0',
            patients: [
                {
                    id: patientId,
                    samples,
                },
            ],
        }
    }

    const handleGenerateEnabledJson = async () => {
        const json = generateEnabledJson()
        console.log(JSON.stringify(json, null, 2))
        // ここで結果表を表示する処理を書く
        const result = await misignalCalculatorAxiosBase().post('/results/check', json, {
            headers: {
                Authorization: process.env.REACT_APP_MISIGNAL_CALCULATOR_API_KEY,
            },
        })

        const patientResultData = result.data['results'][patientId]

        console.log('result!!! patientResultData', patientResultData)

        const testSample: CheckSample = {
            code: 'RC_xxxxxx',
            status: 'APPROVED',
            isInterviewed: true,
            warehousedAt: new Date().toISOString(),
            requestForm: {},
            background: {
                code: 'test',
                age: 60,
            } as any,
            resultJson: patientResultData,
            resultValue: patientResultData.value,
            arrivedAt: new Date().toISOString(),
            patient: {
                id: 0,
                code: 'RL_xxxxxx',
                familyName: '山田',
                familyNameKana: 'ヤマダ',
                givenName: '太郎',
                givenNameKana: 'タロウ',
                email: 'test@craif.com',
                tel: '000-0000-0000',
                birthday: '1980-10-10',
                gender: 'MALE',
                address: {
                    zipCode: '1000000',
                    prefecture: '東京都',
                    city: '千代田区',
                    line: 'テスト町',
                    building: 'テストビル',
                    whole: '1000000 東京都 千代田区 テスト町 テストビル',
                },
            },
        }

        setSample(testSample)
    }
    const formatFormData = (form: Form<CheckTestResultForm>, id: number) => ({
        id,
        date: form.object.inspectionDate,
        value: form.object.resultValue,
        habit: habits.reduce((acc, habit) => {
            acc[habit.key] = form.object[habit.key]
            return acc
        }, {} as Record<string, any>),
        gender: form.object.gender,
    })

    return (
        <>
            <div>
                <CheckControlForm id="form" form={form} title="今回" color="#9002" hideEnableCheck habits={habits} />
                <CheckControlForm id="formPrev" form={formPrev} title="前回(2回前)" color="#9002" habits={habits} />
                <CheckControlForm id="formPrev2" form={formPrev2} title="3回前" color="#9002" habits={habits} />
                <CheckControlForm id="formPrev3" form={formPrev3} title="4回前" color="#9002" habits={habits} />
                <CheckControlForm id="formPrev4" form={formPrev4} title="5回前" color="#9002" habits={habits} />
            </div>
            <Button onClick={handleGenerateEnabledJson} style={{ marginTop: 18 }}>
                決定
            </Button>
        </>
    )
}
type CheckControlFormProps = {
    id: string
    form: Form<CheckTestResultForm>
    title: string
    color: string
    habits: CheckHabit[]
    hideEnableCheck?: boolean
}

const CheckControlForm = ({ id, form, title, color, hideEnableCheck, habits }: CheckControlFormProps) => {
    const enabled = form.object.enabled

    return (
        <div style={{ padding: 20, backgroundColor: color, width: '100%' }}>
            <Flex style={{}}>
                <div style={{ fontWeight: 'bold' }}>{title}</div>
                {!hideEnableCheck && (
                    <div>
                        <CheckboxField form={form} attr="enabled" checkboxLabel="有効" controlId={title} />
                    </div>
                )}
            </Flex>
            {enabled && (
                <>
                    <Flex>
                        <DateField form={form} attr="inspectionDate" label="検査日" style={{ marginBottom: 0 }} />
                    </Flex>
                    <InputField form={form} attr="resultValue" type="number" label="検査結果の数値" step={1} />
                    <div>生活アドバイス</div>
                    <div style={{ fontSize: 14, display: 'flex', flexWrap: 'wrap', gap: 10 }}>
                        {habits.map((habit, index) => (
                            <Flex key={index} justifyContent="space-between" alignItems="center">
                                <InputField form={form} attr={habit.key} label={habit.label} type="number" min={1} max={5} step={1} style={{ width: 80 }} />
                            </Flex>
                        ))}
                    </div>
                </>
            )}
        </div>
    )
}
